module.exports = __webpack_public_path__ + "static/img/qrcode.84ca8fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/qrcode.jpg
// module id = Bt76
// module chunks = 4